import { render, staticRenderFns } from "./SingleProductListComponent.vue?vue&type=template&id=dcfa9c2a&lang=pug&"
import script from "./SingleProductListComponent.vue?vue&type=script&lang=js&"
export * from "./SingleProductListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports